import React, { useRef, useState, useEffect }  from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { Height } from "@material-ui/icons";
import { apiServices } from "../../services/apiServices";

const BMI = (userData)=> {
  console.log("userData",userData)
  const chartRef = useRef(null);
  const [indicatorValues, setindicatorValues] = useState([]);
  const [monthNames, setmonthNames] = useState([]);
  const [maxDates, setmaxDates] = useState([]);

  useEffect(() => {
    let oRequest = {
      "param1":userData.userData.userData.userData.programOwners[0].program,
      "param2":userData.userData.userData.userData.orgUnit, 
      "param3":userData.userData.userData.userData.trackedEntityInstance
    }
  apiServices.postAPI('dashboardIndicator/getPatientData/get_custom_dashboard_BMIdetails', oRequest)
  .then((res) => {
    console.log("BMI>data>>",res.data.data)
    setindicatorValues(res.data.data.map(item => item.indicatorvalue));
    setmonthNames(res.data.data.map(item => item.monthname.trim()));  
    setmaxDates(res.data.data.map(item => item.maxdate));
  })
  .catch((error) => {
    console.log("error",error)
  })
}, []);

console.log("BMI>data>>",indicatorValues, monthNames)
 
  const data = indicatorValues;

  const firstIndexOf25 = data.indexOf(25);

  const secondIndexOf25 = data.indexOf(25, firstIndexOf25 + 1);

  const seriesData = data.map((value, index) => ({
    y: value,
    marker: {
      fillColor: index === secondIndexOf25 ? '#ff779e' : '#00acb1'
    },
    date: maxDates[index],
  }));

  const options = {
    title: {
      text: '',
      align: 'left',
      x: 10,
      y: 10
    },
    xAxis: {
      categories: monthNames,
    },
    yAxis: { 
      title: {
        text: ''
      },
      labels: {
        enabled: false
      },
      tickInterval: 5
    },
    credits:{
      enabled: false,
    },
    legend:{
      enabled: false,
    },
    chart: {
      zoomType: 'none',
      resetZoomButton: false,
      backgroundColor: 'transparent',
      height:'250',
      type:'line',
    },
    series: [{
      name: '',
      connectNulls: true,
      lineColor: '#4472c4',
      lineWidth: 5,
      data: seriesData,
      marker: {
        symbol: 'circle',
        radius: 15,
        states: {
          hover: {
            enabled: false
          }
        }
      },
      dataLabels: {
        enabled: true,
        format: `{y}`,
        style: {
          color: 'white',
          textOutline: 'none',
          fontWeight: 'bold'
        },
        align: 'center',
        verticalAlign: 'middle'
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px"><strong>{point.y}</strong></span><br>',
        pointFormat: '<span style="color:{point.lineColor}">{point.date}</span>: '
    },
    }]
  }
  useEffect(() => {
    if (!chartRef.current) return;


  }, []);

  return (
    <div>
     <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
//   <div ref={chartRef} />

    );
}

export default BMI;
// ReactDOM.render(<SimpleLineChart />, document.getElementById('container'));
